export default function About(props) {
  return (
    <div className={`container p-3 my-3 border`}>
      <h2 className="text-center">About Us</h2>
      <div className="accordion" id="accordionExample">
        <div className={`accordion-item my-2 border bg-${props.mode} text-${props.mode === "light" ? "dark" : "light"}`}>
          <h2 className="accordion-header" id="headingOne">
            <button
              className={`accordion-button border no-out bg-${props.mode} text-${props.mode === "light" ? "dark" : "light"}`}
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseOne"
              aria-expanded="true"
              aria-controls="collapseOne"
            >
              <strong>Analyze Your Text</strong>
            </button>
          </h2>
          <div id="collapseOne" className="accordion-collapse collapse show" aria-labelledby="headingOne" data-bs-parent="#accordionExample">
            <div className="accordion-body">
              TextUtils gives you a way to analyze to your text quickly and efficiently. Be it word count, character count. Thus, it is suitable for writing text with word or
              character limit.
            </div>
          </div>
        </div>
        <div className={`accordion-item my-2 border bg-${props.mode} text-${props.mode === "light" ? "dark" : "light"}`}>
          <h2 className="accordion-header" id="headingTwo">
            <button
              className={`accordion-button collapsed border no-out bg-${props.mode} text-${props.mode === "light" ? "dark" : "light"}`}
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseTwo"
              aria-expanded="false"
              aria-controls="collapseTwo"
            >
              <strong>Free To Use</strong>
            </button>
          </h2>
          <div id="collapseTwo" className="accordion-collapse collapse" aria-labelledby="headingTwo" data-bs-parent="#accordionExample">
            <div className="accordion-body">TextUtils is a free character counter tool that provides instant character count and word count statistics for a given text.</div>
          </div>
        </div>
        <div className={`accordion-item my-2 border bg-${props.mode} text-${props.mode === "light" ? "dark" : "light"}`}>
          <h2 className="accordion-header" id="headingThree">
            <button
              className={`accordion-button collapsed border no-out bg-${props.mode} text-${props.mode === "light" ? "dark" : "light"}`}
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseThree"
              aria-expanded="false"
              aria-controls="collapseThree"
            >
              <strong>Browser Compatible</strong>
            </button>
          </h2>
          <div id="collapseThree" className="accordion-collapse collapse" aria-labelledby="headingThree" data-bs-parent="#accordionExample">
            <div className="accordion-body">
              This word counter software works in any web browsers such as Chrome, Firefox, Edge, Safari, Opera, etc. It suits to count characters in facebook, blog, books, excel
              document, pdf document, essays, etc.
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
